(() => {
  const selector = '[data-promotion-scrolling-text]';

  function initializeTrack(track) {
    if (track.dataset.initialized) return;

    const item = track.firstElementChild;

    if (!item) return;

    while (track.scrollWidth < track.parentElement.offsetWidth * 2) {
      track.appendChild(item.cloneNode(true));
    }

    const items = Array.from(track.children);

    items.forEach(function (item) {
      track.appendChild(item.cloneNode(true));
    });

    track.dataset.initialized = 'true';
  }

  function initializeTracks(root = document) {
    if (root.matches?.(selector)) initializeTrack(root);
    root.querySelectorAll?.(selector).forEach(initializeTrack);
  }

  function initializePromotionScrollingText() {
    initializeTracks();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initializeTracks(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePromotionScrollingText, { once: true });
  } else {
    initializePromotionScrollingText();
  }
})();
